import React from 'react';

type SimpleButtonProps = {
  onClick: () => void;
  id?: string;
  className?: string;
  title: string;
  children?: React.ReactNode;
};

export const SimpleButton: React.FC<SimpleButtonProps> = ({ onClick, id, className, title, children }) => {
  return (
    <button 
      className={`btn ${className} btn-margins`} 
      title={title} 
      onClick={onClick} 
      id={id}>
      {children}
    </button>
  );
}
